import {CookieManager,COOKIE_NAMES} from "./CookieManager";

export class AlcoholBox {

    showSiteMessage() {
        let prodAlcoholSiteButtonYes = document.querySelector('#prod-alcohol-site-button-yes');

        if (null != prodAlcoholSiteButtonYes) {
            prodAlcoholSiteButtonYes.addEventListener("click", (event) => {
                event.preventDefault();
                event.stopPropagation();

                let prodAlcoholAll = document.querySelector('#prod-alcohol-site');
                if (null != prodAlcoholAll) {
                    prodAlcoholAll.style.display = 'none';
                }

                this.hide();

                CookieManager.setCookie(COOKIE_NAMES.alcoholButton, '1', 1);
                return false;

            }, false);
        }
    }

    show() {
        let prodAlcoholButtonYesAll = document.querySelectorAll('.prod-alcohol-button-yes');

        prodAlcoholButtonYesAll.forEach((prodAlcoholButtonYes) => {
            prodAlcoholButtonYes.addEventListener("click", (event) => {
                event.preventDefault();
                event.stopPropagation();

                this.hide();
                CookieManager.setCookie(COOKIE_NAMES.alcoholButton, '1', 1);
                return false;
            }, false);
        });
    }

    hide() {
        const productListItems = document.querySelectorAll('.show-product-item-alcohol-alert');
        productListItems.forEach(element => element.classList.remove('show-product-item-alcohol-alert'));

        const productsContent = document.querySelectorAll('.alcohol-alerting-site');
        productsContent.forEach(element => element.classList.remove('alcohol-alerting-site'));

        let prodAlcoholAll = document.querySelector('#prod-alcohol-site');
        if (null != prodAlcoholAll) {
            prodAlcoholAll.style.display = 'none';
        }
    }

}
